import React from "react";

function ProjectDelivery() {
  const processSteps = [
    {
      title: "Discovery & Sprint Zero",
      description: "Define business outcomes, audit data, and identify opportunities for automation or agent deployment."
    },
    {
      title: "Setup & Orchestration",
      description: "Establish the joint delivery model across humans + AI coworkers. Provision environments and governance protocols."
    },
    {
      title: "Build & Configure",
      description: "Combine agent templates with custom logic and workflows. Integrate into production systems securely."
    },
    {
      title: "Go-Live & Optimization",
      description: "Launch. Monitor. Tune performance. Resolve edge cases. Measure business impact."
    },
    {
      title: "Transfer & Scale",
      description: "Enable internal teams to extend, replicate, and manage what's been built - with training, documentation, and live support."
    }
  ];

  return (
    <div className="py-12 md:py-18">
      <div className="container mx-auto px-4 md:px-8 lg:px-16">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-white mb-10 md:mb-12">
            <h2 className="RoobertLight text-4xl md:text-5xl lg:text-6xl font-light mb-4">
              How we deliver projects
            </h2>
            <h3 className="RoobertMedium text-xl md:text-2xl font-bold mb-4">
              Outcome-led. Sprint-driven. Structured for scale.
            </h3>
            <p className="RoobertRegular text-lg">
              Each project follows a clear rhythm designed for speed and sustainability:
            </p>
          </div>

          {/* Process Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-16">
            {processSteps.map((step, index) => (
              <div key={index} className="relative bg-white text-black p-6 md:p-8">
                {/* Green border accent */}
                <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-16 h-16"></div>
                
                <h4 className="RoobertMedium text-lg md:text-xl font-bold mb-4">
                  {step.title}
                </h4>
                <p className="RoobertRegular text-sm md:text-base leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectDelivery;
